import classNames from "classnames";
import React from "react";

import styles from "./Checkbox.module.scss";

interface Props {
    checked?: boolean;
    label?: string;
    disabled?: boolean;
    onClick: () => void;
    classes?: {
        root?: string;
        button?: string;
        label?: string;
    };
}

const Checkbox = ({ checked, label, onClick, disabled, classes }: Props) => {
    return (
        <label className={classNames(styles.checkbox, classes?.root)}>
            <button
                disabled={disabled}
                onClick={onClick}
                className={classNames(styles["checkbox__box"], classes?.button, {
                    [styles["checkbox__box--active"]]: checked,
                    [styles["checkbox__box--inactive"]]: !checked,
                })}
            ></button>
            {label && (
                <span className={classNames(styles["checkbox__label"], classes?.label)}>
                    {label}
                </span>
            )}
        </label>
    );
};

export default Checkbox;
